import loadable from 'sku/@loadable/component';

export default loadable(() => import('./Root'));
